<div>
  <div class="flex items-center justify-between my-2 sm:my-4 w-full">
    <!--    logo-->
    <section class="self-start ml-0 pl-0">
      <button (click)="OnLogoClicked()" class="cursor-pointer">
        @if(currentScreenSize() === 'LG') {
          <ln-logo-svg-icon [class]= '"w-[224px] h-[128px]"'></ln-logo-svg-icon>
        } @else {
           @if(currentScreenSize() === 'MD') {
             <ln-logo-svg-icon [class]= '"w-[156px] h-[92px]"'></ln-logo-svg-icon>
           } @else {
             <ln-logo-svg-icon [class]= '"w-[122px] h-[60px]"'></ln-logo-svg-icon>
           }
        }

      </button>
    </section>
    <!--    buscador-->
<!-- class="hidden sm:block sm:flex-auto sm:mx-10"  -->
    <section [ngClass]="[currentScreenSize() === 'SM' ? 'hidden': 'block flex-auto mx-10']">
      <ln-search-bar></ln-search-bar>
    </section>
    <!--  menu-->
    <section>
<!--      class="md:flex-1"-->
      <ln-main-menu  [showSearchBarOnDemand]="showSearchBarOnDemand"></ln-main-menu>
    </section>
  </div>
  @if (showSearchBarOnDemand()) {
    <section class="flex-auto mb-2">
      <ln-search-bar></ln-search-bar>
    </section>
  }
</div>
